
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="fixed top-0 left-0 right-0 z-50">
        <Navbar staticHeader={true} />
      </div>
      <main className="flex-grow pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold mb-8 text-foreground">Terms of Service</h1>
          <div className="prose prose-lg max-w-none">
            <p className="text-muted-foreground mb-6">Last Updated: April 30, 2025</p>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">1. Acceptance of Terms</h2>
              <p className="mb-4">
                By accessing or using AuthorPro.ai ("the Service"), you agree to be bound by these Terms of Service ("Terms"). 
                If you disagree with any part of the terms, you may not access the Service.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">2. Description of Service</h2>
              <p className="mb-4">
                AuthorPro.ai provides a platform for authors to transform their books into interactive AI-powered coaching platforms.
                We reserve the right to modify or discontinue, temporarily or permanently, the Service with or without notice.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">3. User Accounts</h2>
              <p className="mb-4">
                When you create an account with us, you must provide accurate, complete, and current information. Failure to do so 
                constitutes a breach of the Terms, which may result in immediate termination of your account.
              </p>
              <p className="mb-4">
                You are responsible for safeguarding the password and for all activities that occur under your account. 
                You agree not to disclose your password to any third party.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">4. Intellectual Property</h2>
              <p className="mb-4">
                The Service and its original content, features, and functionality are owned by AuthorPro.ai and are protected by 
                international copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>
              <p className="mb-4">
                You retain all rights to your content that you upload, post, or display on or through the Service. By uploading 
                content to the Service, you grant us a worldwide, non-exclusive license to use, reproduce, modify, adapt, publish, 
                translate, and distribute such content in connection with providing the Service.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">5. Prohibited Uses</h2>
              <p className="mb-4">You agree not to use the Service:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>In any way that violates any applicable national or international law or regulation.</li>
                <li>To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail," "chain letter," or "spam."</li>
                <li>To impersonate or attempt to impersonate AuthorPro.ai, an employee, another user, or any other person or entity.</li>
                <li>To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Service.</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">6. Limitation of Liability</h2>
              <p className="mb-4">
                In no event shall AuthorPro.ai, its directors, employees, partners, agents, suppliers, or affiliates, be liable for any 
                indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, 
                use, goodwill, or other intangible losses, resulting from:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Your access to or use of or inability to access or use the Service.</li>
                <li>Any conduct or content of any third party on the Service.</li>
                <li>Any content obtained from the Service.</li>
                <li>Unauthorized access, use, or alteration of your transmissions or content.</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">7. Termination</h2>
              <p className="mb-4">
                We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, 
                including without limitation if you breach the Terms.
              </p>
              <p className="mb-4">
                Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, 
                you may simply discontinue using the Service.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">8. Governing Law</h2>
              <p className="mb-4">
                These Terms shall be governed and construed in accordance with the laws of the United States, without regard 
                to its conflict of law provisions.
              </p>
              <p className="mb-4">
                Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. 
                If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of 
                these Terms will remain in effect.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">9. Changes to Terms</h2>
              <p className="mb-4">
                We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide 
                notice of changes by posting the updated terms on this page. Your continued use of the Service after any such changes 
                constitutes your acceptance of the new Terms.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">10. Contact Us</h2>
              <p className="mb-4">
                If you have any questions about these Terms, please contact us at:
              </p>
              <p className="mb-4">
                Email: <a href="mailto:info@series-a.co.uk" className="text-gold hover:text-gold-light">info@series-a.co.uk</a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
